import React, { useEffect } from "react";
// useRef
// import First from "./First";
// import { Carousel } from "antd";
// import Second from "./Second";
// import Third from "./Third";
import { useHistory } from "react-router-dom";
import { isLogin } from "../../constant/helper";
// import { isLogin } from "../../constant/helper";

const Intro = () => {
  // const carouselSettings = {
  //   effect: "fade",
  //   infinite: false,
  //   dots: true,
  //   slidesToShow: 1,
  //   initialSlide: 2,
  // };

  let history = useHistory();

  useEffect(() => {
    if (isLogin()) {
      history.push("/home");
    } else {
      history.push("/login");
    }
  }, [history]);

  // const sliderRef = useRef();

  // useEffect(() => {
  //   const isAuthenticated = isLogin();
  //   if (isAuthenticated) history.push("/home");

  //   goNext(2);
  //   //eslint-disable-next-line
  // }, []);

  // useEffect(() => {
  //   const isAuthenticated = isLogin();
  //   if (isAuthenticated) history.push("/home");
  // }, [history]);

  // function goNext(slideIndex = null) {
  //   if (sliderRef.current && slideIndex !== null) {
  //     sliderRef.current.goTo(slideIndex);
  //   }
  // }

  return <div></div>;
  //  (
  // <div id="intro">
  //   <Carousel ref={sliderRef} {...carouselSettings}>
  //     <div>
  //       <Third />
  //     </div>

  //     <div>
  //       <Second
  //         next={() => {
  //           goNext(0);
  //         }}
  //       />
  //     </div>

  //     <div>
  //       <First
  //         next={() => {
  //           goNext(1);
  //         }}
  //       />
  //     </div>
  //   </Carousel>
  // </div>
  // )
};

export default Intro;
